export default __webpack_public_path__ + "static/media/IMG_2973.abf2e7e0.jpg";